import { ReactComponent as ValidCompleteSVG } from 'assets/svg/valid-complete.svg';

export default function ValidCompleteIcon() {
  return (
    <span className="valid-status complete">
      <ValidCompleteSVG />
    </span>
  );
}
